import { IHlaAllele } from './hla-allele';
import { IHlaEplet } from './hla-eplet';

export interface IAlleleEplet {
    id: number;
    alleleId: number;
    allele: IHlaAllele;
    epletId: number;
    eplet: IHlaEplet;
}